import React from "react";
import { Text } from "@chakra-ui/react";

/**
 * FieldLabel — the tiny uppercase field/section label used across the migrated
 * portal forms and detail panels (template `.label`). Consolidates the per-file
 * `FieldLabel`/`InputLabel` helpers the migration duplicated.
 *
 * Props:
 *   children    - the label text
 *   isRequired  - appends a `*` in `portal.danger` (visual required marker)
 *   htmlFor     - when set, renders as a real <label for=…> for a11y association
 *   ...rest     - style/prop overrides forwarded to the underlying Chakra Text
 *
 * Note: `isRequired` is visual only; required <input>s should also carry
 * `aria-required` (or sit in a Chakra FormControl isRequired) for assistive tech.
 */
const FieldLabel = ({ children, isRequired = false, htmlFor, ...rest }) => (
  <Text
    {...(htmlFor ? { as: "label", htmlFor } : {})}
    fontSize="10px"
    textTransform="uppercase"
    fontWeight="800"
    letterSpacing="0.055em"
    color="portal.muted"
    {...rest}
    sx={{ marginBottom: "4px !important", display: "block", ...(rest.sx || {}) }}
  >
    {children}
    {isRequired && (
      <Text as="span" color="portal.danger" ml="2px">
        *
      </Text>
    )}
  </Text>
);

export default FieldLabel;
